(() => {
  const EXPANDED_CLASS = 'is-expanded';
  const HIDDEN_CLASS = 'hidden';
  const RESIZE_DEBOUNCE = 150;

  class ReadMoreText extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('[data-read-more-body]');
      this.toggle = this.querySelector('[data-read-more-toggle]');
      if (!this.body || !this.toggle) return;

      // The clamp is a CSS max-height, so overflow is the only honest signal that
      // there is anything left to reveal — and it re-answers itself at every width.
      // A multi-column body spills sideways into extra columns rather than down,
      // so both axes have to be checked or those sections never get a toggle.
      this.syncToggle = () => {
        if (this.classList.contains(EXPANDED_CLASS)) return;

        const overflowing =
          this.body.scrollHeight > this.body.clientHeight + 1 || this.body.scrollWidth > this.body.clientWidth + 1;

        this.toggle.classList.toggle(HIDDEN_CLASS, !overflowing);
      };

      this.expand = () => {
        this.classList.add(EXPANDED_CLASS);
        this.toggle.classList.add(HIDDEN_CLASS);
      };

      this.handleResize = () => {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(this.syncToggle, RESIZE_DEBOUNCE);
      };

      this.controller = new AbortController();
      const { signal } = this.controller;

      this.toggle.addEventListener('click', this.expand, { signal });
      window.addEventListener('resize', this.handleResize, { signal });

      this.syncToggle();
    }

    disconnectedCallback() {
      window.clearTimeout(this.resizeTimer);
      this.controller?.abort();
    }
  }

  if (!customElements.get('read-more-text')) {
    customElements.define('read-more-text', ReadMoreText);
  }
})();
